import Bar from './src/Bar.vue'

Bar.install = function(Vue) {
    Vue.component(Bar.name, Bar)
}

export default Bar